import {
  LinkWithButtonStyles,
  Modal,
} from '@frontendmentorio/design-system-v2';

import ProFlag from 'features/shared/ProFlag';

export default function SuccessModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>Thanks for becoming a Pro member! 🎉</Modal.Heading>

      <p>
        As a Pro member you’ll be given everything you need in order to practice
        like a professional. You’ll also be given a <ProFlag /> label that will
        show your support for the community.
      </p>

      <p>
        A great place to start would be to find a challenge that you’d like to
        try. Remember, you can now dive into our premium challenges!
      </p>

      <LinkWithButtonStyles
        className="self-center"
        href="/challenges"
        isWide
        onClick={modal.close}
      >
        Browse challenges
      </LinkWithButtonStyles>
    </Modal>
  );
}
